import { Box, Skeleton } from '@mui/material'

const DetailsRequestSkeleton = () => (
  <>
    <Box sx={customStyles.detailsContainer}>
      <Box sx={styles.DataInfo}>
        <Box sx={customStyles.detailsData}>
          <Skeleton variant="text" sx={customStyles.detailsInfo} />
          <Skeleton variant="text" sx={customStyles.detailsItem} />
        </Box>
        <Box sx={customStyles.detailsData}>
          <Skeleton variant="text" sx={customStyles.detailsInfo} />
          <Skeleton variant="text" sx={customStyles.detailsItem} />
        </Box>
        <Box sx={customStyles.detailsData}>
          <Skeleton variant="text" sx={customStyles.detailsInfo} />
          <Skeleton variant="text" sx={customStyles.detailsItem} />
        </Box>
      </Box>
      <Box sx={styles.DataInfo}>
        <Box sx={customStyles.detailsData}>
          <Skeleton variant="text" sx={customStyles.detailsInfo} />
          <Skeleton variant="text" sx={customStyles.detailsItem} />
        </Box>
        <Box sx={customStyles.detailsData}>
          <Skeleton variant="text" sx={customStyles.detailsInfo} />
          <Skeleton variant="text" sx={customStyles.detailsItem} />
        </Box>
        <Box sx={customStyles.detailsData}>
          <Skeleton variant="text" sx={customStyles.detailsInfo} />
          <Skeleton variant="text" sx={customStyles.detailsItem} />
        </Box>
      </Box>
    </Box>
    <Box sx={customStyles.detailsComment}>
      <Skeleton variant="text" sx={customStyles.commentInfo} />
      <Skeleton variant="text" sx={customStyles.commentItem} />
    </Box>
  </>
)
const customStyles = {
  detailsHeader: {
    width: '100%',
    display: 'flex',
    gap: '10px',
  },
  detailsContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: 'center',
    padding: '20px',
    gap: { xs: '10px', sm: '50px' },
  },
  detailsData: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    gap: '50px',
    marginBlock: '10px',
  },
  detailsInfo: {
    width: '100px',
    height: '20px',
  },
  detailsItem: {
    width: '150px',
    height: '20px',
  },
  commentInfo: {
    width: '100px',
    height: '20px',
  },
  commentItem: {
    width: { xs: '150px', sm: '500px' },
    height: '20px',
  },
  detailsComment: {
    display: 'flex',
    justifyContent: { xs: 'space-between', sm: 'flex-start' },
    width: { xs: 'unset', sm: '100%' },
    gap: { xs: '50px', sm: '50px' },
    marginBlock: { xs: '0px', sm: '10px' },
    paddingInline: '20px',
  },
}

const styles = {
  DataInfo: {
    width: { xs: '100%', sm: '50%' },
  },
}
export default DetailsRequestSkeleton
